/* eslint-disable react/jsx-pascal-case */
import React from 'react';
import PositionChaild from './PositionChaild';

export default class MenuPositionParent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            language: 'rus',
            show1: false,
            // url: ''
        }

        this.doTransferUrl = this.doTransferUrl.bind(this);
        this.handleClickShow = this.handleClickShow.bind(this);
    }

    handleClickShow(e) {
        this.setState({ show1: !this.state.show1 })
    }


    async doTransferUrl(url) {
        this.props.onTransferUrl(url);
    }

    render() {

        const show = this.props.show;
        const name = this.props.name;
        const icon = this.props.icon;
        const eventKey = this.props.eventKey;


        return (
            <>
                <div className="menu-position-parent" >
                    <PositionChaild
                        icon={icon}
                        name={name}
                        show={show}
                        nameMenu={this.props.nameMenu}
                        urlMenu={this.props.urlMenu}
                        onTransferUrl={this.doTransferUrl}
                        eventKey={eventKey}
                        url={this.props.url}
                        isSectionOpen={this.props.isSectionOpen}
                        numberOfSection={this.props.numberOfSection}
                        onAccordionOpen={this.props.onAccordionOpen}
                    />

                </div>
            </>
        )
    }
}